<template>
  <div>
    <div class="cover-table">
      <Table
        border
        style="width: 100%;"
        :loading="loading"
        :columns="tableColumns"
        :data="tableData"
        highlight-row
      >
        <!-- <template slot-scope="{ row, index }" slot="action">
                    <span class="pointer" @click="handleDeal('projectDetail',row.id)">详情</span>
                </template> -->
      </Table>
      <Page
        class="page"
        :total="totalCount"
        :page-size="pageSize"
        :current="page"
        @on-change="changePage"
        @on-page-size-change="pageSizeChange"
        show-elevator
        show-sizer
        show-total
        transfer
      >
      </Page>
    </div>
  </div>
</template>
<script>
import tableMixin from "@/components/tableMixin";
import tableTwoMixin from "@/components/tableTwoMixin";
export default {
  data() {
    return {
      tableColumns: [
        {
          title: "序号",
          type: "index",
          width: 70,
          fixed: "left",
          align: "center",
        },
        {
          title: "项目编号",
          key: "projectId",
          minWidth: 100,
          tooltip: true,
          align: "center",
        },
        {
          title: "班组编号",
          key: "teamId",
          minWidth: 210,
          tooltip: true,
          align: "center",
        },
        {
          title: "证件类型",
          key: "idCardType",
          minWidth: 180,
          tooltip: true,
          align: "center",
        },
        {
          title: "证件号码",
          key: "idCardNumber",
          minWidth: 140,
          tooltip: true,
          align: "center",
        },
        {
          title: "刷卡时间",
          key: "date",
          minWidth: 180,
          tooltip: true,
          align: "center",
        },
        {
          title: "刷卡进出方向",
          key: "direction",
          minWidth: 100,
          tooltip: true,
          align: "center",
        },
        {
          title: "刷卡近照",
          key: "imageUrl",
          minWidth: 210,
          tooltip: true,
          align: "center",
          render: (h) => {
            return h("img", {
              attrs: {
                src: "imageUrl",
              },
              style: {
                width: "180px",
                height: "100px",
                margin: "0 auto",
              },
            });
          },
        },
        {
          title: "通道的名称",
          key: "channel",
          minWidth: 180,
          tooltip: true,
          align: "center",
        },
        {
          title: "通行方式",
          key: "attendType",
          minWidth: 140,
          tooltip: true,
          align: "center",
        },
        {
          title: "WGS84经度",
          key: "lng",
          align: "center",
          minWidth: 120,
          tooltip: true,
        },
        {
          title: "WGS84纬度",
          key: "lat",
          minWidth: 120,
          tooltip: true,
          align: "center",
        },
        {
          title: "工人体温",
          key: "temperature",
          align: "center",
          minWidth: 100,
        },
        {
          title: "数据来源",
          key: "sourceAreaCode",
          align: "center",
          minWidth: 100,
        },
      ],
    };
  },
  mixins: [tableMixin, tableTwoMixin],
  mounted() {},
  methods: {},
};
</script>
